import * as React from 'react';
import { useFormik } from 'formik';
import { Constants, Validators } from 'core';
import { Situation, SituationForm, RequestError } from 'types';
import { useSelector } from 'react-redux';
import { Select } from 'antd';
import styled from 'styled-components';
import { path } from 'ramda';

import { useIntl } from 'common/config/i18n';
import FormError from 'components/molecules/form-error';
import { StyledRepositoryForm, StyledRepositoryFormButtonWrapper } from 'common/styling/mixins';
import Button from 'components/molecules/button';
import Input from 'components/organisms/input';
import { SituationCategorySelectors } from 'common/config/store';

const Label = styled.div`
  font-size: ${path(['theme', 'font', 'size', 'body'])};
  font-weight: bold;
`;
interface Props {
  onSubmit: (values: SituationForm) => void;
  situation?: Situation;
  error?: RequestError;
  status?: 'loading' | 'error' | 'success';
}
const { Option } = Select;

const Form = (props: Props) => {
  const { t } = useIntl();
  const isUpdate = !!props.situation;
  const situationCategoryById = useSelector(SituationCategorySelectors.situationCategorySelector);
  const initialValues = {
    situationCategoryID:
      props.situation && props.situation.situationCategory.id ? props.situation.situationCategory.id : undefined,
    name: props.situation && props.situation.name ? props.situation.name : '',
  };
  const formik = useFormik({
    initialValues,
    validate: (values) => Validators.formSituation(values),
    onSubmit: (values) => {
      props.onSubmit(values);
    },
  });

  return (
    <StyledRepositoryForm onSubmit={formik.handleSubmit}>
      <div className="formSection">
        <Label>{t('table', 'CHART_PROCESS')}</Label>
        <Select
          value={formik.values.situationCategoryID}
          onChange={(value) => formik.setFieldValue('situationCategoryID', value)}
          allowClear
        >
          {situationCategoryById.map((x) => (
            <Option value={x.id} key={x.id}>
              {x.name}
            </Option>
          ))}
        </Select>
        <FormError formik={formik} fieldName="situationCategoryID" />
      </div>
      <div className="formSection">
        <Input
          upLabel={t('form', 'FORM_SITUATION')}
          name="name"
          onChange={formik.handleChange}
          value={formik.values.name}
          width="100%"
        />
        <FormError formik={formik} fieldName="name" />
      </div>

      <StyledRepositoryFormButtonWrapper>
        <Button
          height="35px"
          width="100%"
          borderRadius="20px"
          disabled={
            !!(formik.errors.situationCategoryID && formik.touched.situationCategoryID) ||
            !!(formik.errors.name && formik.touched.name)
          }
          htmlType="submit"
          loading={props.status === 'loading'}
        >
          {t('Buttons', isUpdate ? 'SAVE_BUTTON' : 'CREATE_BUTTON')}
        </Button>
      </StyledRepositoryFormButtonWrapper>
      {props.error && (
        <FormError
          message={
            props.error === Constants.ALREADY_EXISTED_PROBLEM_CODE
              ? t('form', 'FORM_SITUATION_ALLREADY_EXIST')
              : t('form', 'FORM_UNKNOWN_ERROR')
          }
        />
      )}
    </StyledRepositoryForm>
  );
};
export default Form;
